import React, { useEffect, useState } from 'react';
import { Tooltip, Modal } from 'antd';
import { Button, ColumnProps, FormSubmitButton, MasterDetailForm, Table } from '@digital/ui';
import * as Yup from 'yup';
import { UploadMultipleTableTmp } from '@app/components';
import { getArquivosDocumentoOrdemCompraByOc, incluirDocumento } from '@app/api/sas/sasDocumentoOrdemCompra';
import { getPropostasOrdemCompra, ISasPropostaOrdemCompra } from '@app/api/sas/sasProposta';
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { ordemCompraIdState, vendorListState } from '../atoms';
import { IArquivo } from '@app/types/core.types';

interface Props {
    sasPropostaId: string;
}

const ModalPropostaTecnicaConsolidada = ({ sasPropostaId }: Props) => {
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const setVendorList = useSetRecoilState(vendorListState);
    const [exibirModal, setExibirModal] = useState(false);
    const [arquivos, setArquivos] = useState<IArquivo[]>([]);

    const loadArquivos = async () => {
        return await getArquivosDocumentoOrdemCompraByOc({
            ordemCompraId,
            sasTipoDocumentoId: EGuidTipoSasDocumento.PropostaTecnicaConsolidada,
            sasPropostaId,
        }).then((data) => {
            const itens = data || [];
            setArquivos(itens);
            return itens;
        });
    };

    useEffect(() => {
        if (exibirModal) {
            setArquivos([]);
            loadArquivos();
        }
    }, [exibirModal]);

    const columns = (): ColumnProps<IArquivo>[] => ([
        {
            title: 'Arquivo',
            dataIndex: 'nome',
        },
        {
            title: 'Status',
            className: 'td-centralizado',
            dataIndex: 'status',
            width: '15%',
        },
        {
            title: 'Versão',
            className: 'td-centralizado',
            dataIndex: 'versao',
            width: '10%',
        },
    ]);

    const onSubmit = (values: any) => {
        const arquivoVigente = arquivos.find((a) => a.status === 'Vigente') || arquivos[0];
        const documentoIdVigente = arquivoVigente ? arquivoVigente.sasDocumentoId : undefined;
        const novosArquivos = values && values.arquivos
            ? values.arquivos.filter((a: any) => !!a)
            : [];

        if (!novosArquivos || novosArquivos.length === 0) return Promise.resolve(false);

        return incluirDocumento({
            ordemCompraId,
            sasPropostaId,
            sasTipoDocumentoId: EGuidTipoSasDocumento.PropostaTecnicaConsolidada,
            descricao: 'Proposta Técnica Consolidada',
            multiple: true,
            files: novosArquivos,
            documentoId: documentoIdVigente,
        }).then((data: any) => {
            if (data) {
                getPropostasOrdemCompra({
                    ordemCompraId,
                    isAtivas: true,
                }).then((propostas: ISasPropostaOrdemCompra[]) => {
                    if (propostas) {
                        setVendorList(propostas);
                    }
                });
                setExibirModal(false);
                return true;
            }
            return false;
        });
    };

    return (
        <>
            <Tooltip title="Proposta Técnica a ser enviada para o Gestor Técnico">
                <Button icon="ui-upload" onClick={() => setExibirModal(true)} />
            </Tooltip>
            <Modal
                title="Proposta Técnica a ser enviada para o Gestor Técnico"
                visible={exibirModal}
                onCancel={() => setExibirModal(false)}
                footer={null}
                width="680px"
            >
                {exibirModal && (
                    <MasterDetailForm
                        onSubmit={onSubmit}
                        validationSchema={Yup.object().shape({
                            arquivos: Yup.array().min(1, 'É necessário anexar no mínimo um arquivo.'),
                        })}
                        actions={[
                            <Button type="link" onClick={() => setExibirModal(false)}>Fechar</Button>,
                            <FormSubmitButton noIcon type="primary">Salvar</FormSubmitButton>,
                        ]}
                    >
                        <UploadMultipleTableTmp
                            idDoComponente="arquivosPropostaTecnicaConsolidada"
                            name="arquivos"
                            type="primary"
                            tablePagination={false}
                            onGetArquivos={async () => []}
                        />

                        <Table
                            dataSource={arquivos}
                            columns={columns()}
                            rowKey="id"
                            pagination={arquivos.length > 10 ? { pageSize: 10 } : false}
                        />
                    </MasterDetailForm>
                )}
            </Modal>
        </>
    );
};

export default ModalPropostaTecnicaConsolidada;
